import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { OrganismService } from '../partners/organisms/organisms.service';
import { UserService } from 'src/app/user/user.services';
import { OrganismModel } from 'src/app/partners/organisms/organism.model';
import { UserDetailsModel } from 'src/app/user/user.details.model';
import { AddUserComponent } from 'src/app/user/add-user/add-user.component';
import { UserModel } from 'src/app/user/add-user/user.model';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { SharedService } from '../utils/shared.service';
import { GridApi } from 'ag-grid-community';
import { LoaderService } from '../common/loader.service';
@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit {

  columnDefs: any[];
  rowData: any[];
  addUser;
  userSerch: UserDetailsModel = new UserDetailsModel();
  organismSearch: OrganismModel = new OrganismModel();
  profileList: any = [];
  organismList: OrganismModel[] = [];
  userSearchForm: FormGroup;  
  gridApi: GridApi;
  @ViewChild(AddUserComponent, { static: true }) newUser: AddUserComponent;
  userOrgsmId: number;
  constructor(private formBuilder: FormBuilder,public router: Router, private organismService: OrganismService, private sharedService:SharedService,private userService: UserService,private loaderService: LoaderService) {
    this.sharedService.userOrgsmId$.subscribe(res => {
      this.userOrgsmId = res;
    })
    this.getFromGroup();
    this.columnDefs = [
      /* { headerName: 'Id', field: 'secUsrId', width: 50 }, */
      { headerName: 'Login', field: 'secUsrLogin', width: 200 },
      { headerName: 'Name', field: 'empName', width: 250 },
      { headerName: 'Profile', field: 'prfileDescEn', width: 200 },
      { headerName: 'Sub Profile', field: 'subprofileDescEn', width: 200 },
      { headerName: 'Organism', field: 'compaVaNameEn', width: 250 }
    ];

this.serchUser();
  }
  serchUser(){
    if(this.userOrgsmId){
      this.userSearchForm.patchValue({orgsmId:this.userOrgsmId});
    }
    this.userSearchForm.patchValue({staRecCode:this.f.staRecCode.value ? 'A' :'I'});
    this.loaderService.display(true);
    this.userService.searchUser(this.userSearchForm.value).subscribe(response => {
      this.loaderService.display(false);
      this.rowData = response['result'];
    })

  }
  reset(){
    this.userSearchForm.reset();
  }
  onRowClicked(event: any) {
    this.addUser = true;
    this.loadUser(event);
  }
  addNewUser() {
    this.router.navigate(['addUser']);
  }
  hideRightDiv() {
    this.addUser = false;
  }
  ngOnInit() {
    this.loadOrganisms();
    this.loadProfile();
  }
  loadProfile() {
    this.userService.getProfile().subscribe(response => {
      this.profileList = response['result'];
    })
  }
  loadOrganisms() {
    this.organismService.searchOrganisms(this.organismSearch).subscribe(response => {
      this.organismList = response['result'];
    })
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }
  loadUser(event: any) {
    this.userService.getUserDetailsById(event.data.secUsrId).subscribe(response => {
     // this.newUser.user = new UserModel();
      if (response['code'] == 'S0000') {
        //this.newUser.loadDetailsByProfileId(JSON.parse(JSON.stringify(response['result'])).tuSecUserDetail.secProId);
        this.newUser.patchFormValues(response['result']);
        
      }

    })

  }
  get f() { return this.userSearchForm.controls; }

  private getFromGroup() {
    this.userSearchForm = this.formBuilder.group({
      'orgsmId': new FormControl(),
      'secUsrLogin': new FormControl(),
      'empName': new FormControl(),
      'secProId': new FormControl(),
      'staRecCode':[true]
    })
  }
}
